import type {
  FinancialStatementsFilters,
  FinancialStatementsFilterKeys,
  FinancialStatementsFilterParams
} from '../types'

/**
 * Converts FinancialStatementsFilters to FinancialStatementsFilterKeys
 * Used for React Query cache keys and contains all data needed for API requests
 */
export const toFilterKeys = (filters: FinancialStatementsFilters): FinancialStatementsFilterKeys => {
  return {
    companyId: filters.companyId || '',
    budgetingScenarioId: filters.budgetingScenarioId ? String(filters.budgetingScenarioId) : undefined,
    periodGroups: filters.periodGroups?.map(({ id, startDate, endDate, budgetable }) => ({
      id,
      startDate,
      endDate,
      budgetable
    })),
    dimensions: filters.dimensions ? [filters.dimensions] : [],
    dimension: filters.dimension,
    lng: filters.lng || 'en'
  }
}

/**
 * Derives FinancialStatementsFilterParams from FinancialStatementsFilterKeys
 * Converts filter keys to the format needed for API requests
 */
export const toFilterParams = (filterKeys: FinancialStatementsFilterKeys): FinancialStatementsFilterParams => {
  return {
    companyId: filterKeys.companyId,
    budgetingScenarioId: filterKeys.budgetingScenarioId,
    periodGroups: filterKeys.periodGroups,
    dimensions: filterKeys.dimensions?.[0], // Extract first dimension from array
    dimension: filterKeys.dimension,
    lng: filterKeys.lng
  }
}

/**
 * Converts FinancialStatementsFilterKeys back to FinancialStatementsFilters
 * Useful for debugging or reverse conversion
 */
export const fromFilterKeys = (keys: FinancialStatementsFilterKeys): Partial<FinancialStatementsFilters> => {
  return {
    companyId: keys.companyId,
    budgetingScenarioId: keys.budgetingScenarioId ? Number(keys.budgetingScenarioId) : undefined,
    periodGroups: keys.periodGroups as any, // Cast to PeriodGroup[] - may need proper mapping
    dimensions: keys.dimensions?.[0],
    lng: keys.lng as any
  }
}
